import React from 'react'
import AnalyticsDashboard from '../../../Components/Dashboard/Analytics'
import { useAuth } from '../../../Context/AuthContext';
import { Card, CardBody, Container, Row, Col, Button } from 'reactstrap';
import { H3, P } from '../../../AbstractElements';
import { ShieldOff } from 'react-feather';
import Breadcrumbs from '../../../CommonElements/Breadcrumbs';

export default function Analytics() {
  const { hasPermission } = useAuth();

  if (!hasPermission('dashboard.view')) {
    return (
      <div className='page-body'>
        <Container fluid>
          <Row className="justify-content-center align-items-center" style={{ minHeight: '65vh', top: "50vh" }}>
            <Col md={6} lg={5} xl={4} className="text-center">
              <Card className="border-0 shadow-lg" style={{ borderRadius: '24px', overflow: 'hidden', background: '#ffffff' }}>
                <div style={{
                  height: '8px',
                  background: 'linear-gradient(90deg, #308e87 0%, #4facfe 100%)'
                }} />
                <CardBody className="p-5">
                  <div className="mb-4 d-inline-flex align-items-center justify-content-center" style={{
                    width: '90px',
                    height: '90px',
                    backgroundColor: '#f8f9fa',
                    borderRadius: '50%',
                    color: '#308e87',
                    boxShadow: 'inset 0 2px 4px rgba(0,0,0,0.05)'
                  }}>
                    <ShieldOff size={42} strokeWidth={1.5} />
                  </div>

                  <H3 className="fw-bold mb-3" style={{ color: '#2c3e50', letterSpacing: '-0.5px' }}>Access</H3>

                  <P className="text-muted mb-4 px-2" style={{ fontSize: '1rem', lineHeight: '1.7' }}>
                    Your current account doesn't have the necessary administrative privileges to access the analytics dashboard. Please contact your system administrator if you believe this is an error.
                  </P>

                  <div className="d-grid mt-4">
                    <Button
                      color="primary"
                      className="py-3 fw-bold shadow-sm"
                      style={{
                        borderRadius: '12px',
                        backgroundColor: '#308e87',
                        border: 'none',
                        transition: 'transform 0.2s'
                      }}
                      onMouseOver={(e) => e.currentTarget.style.transform = 'translateY(-2px)'}
                      onMouseOut={(e) => e.currentTarget.style.transform = 'translateY(0)'}
                      onClick={() => window.history.back()}
                    >
                      <span className="d-flex align-items-center justify-content-center gap-2">
                        Go Back
                      </span>
                    </Button>
                  </div>
                </CardBody>
              </Card>
              <P className="mt-4 text-muted small">Supportoo Security System</P>
            </Col>
          </Row>
        </Container>
      </div>
    );
  }


  return (
    <div className='page-body'>
      <AnalyticsDashboard />
    </div>
  )
}
